module.exports = __webpack_public_path__ + "media/images/flags/16/Croatia-57d5e29c5c5d14a63cd6d03f95acd907.png";